export default __webpack_public_path__ + "static/media/tasks-icon.bdabd672.svg";